// 此文件会被单独上传，不能引用任何其他文件

module.exports = {
  product_id: 4,
  template: 'hy',
  prodKey: 'ut-dunion-freight',
  type: 3, // 哪种H5渲染模式 ssg 3 /ssr 2 / csr 1
  sdkRenderType: 'template', // 本次新增：当前产品调用渲染sdk哪种渲染能力。
  // vue-server-renderer里注入prefetch相关模块
  // shouldPrefetch: (file, type) => {
  //   const reg = /ut-launch-ui-(\d)+.[0-9a-fA-F]{16}.js$/
  //   if (type === 'script' && !reg.test(file)) {
  //     // hack ：动态import 的模块添加chuckname，在这里匹配，从prefetch进行排除，避免不必要的资源渲染到html的head中
  //     return true
  //   }
  // },
}
